// extracted by mini-css-extract-plugin
export default {"stamp":"label_stamp__Crxbb","black":"label_black__+zw5z","yellow":"label_yellow__p+jnz","red":"label_red__Ec+pz","green":"label_green__wIY0k"};